import { useEffect, useRef } from 'react'
import { LiveTranscriptionCapture } from '../services/live-transcription-capture'

/**
 * Starts/stops this participant's own mic -> transcription-server upload
 * alongside the meeting, gated on the meeting's own transcription setting —
 * never on the personal "show captions" toggle, which only controls what
 * this viewer sees (see MeetingScreen's captionsOn vs
 * transcriptionEnabledForSession).
 *
 * One instance for the hook's lifetime; restarts the graph when the track
 * itself changes (a mic switch), not on every render.
 */
export function useLiveTranscriptionCapture(
  audioTrack: MediaStreamTrack | null | undefined,
  roomId: string | null,
  peerId: string | null | undefined,
  displayName: string | null | undefined,
  enabled: boolean,
): void {
  const captureRef = useRef<LiveTranscriptionCapture | null>(null)

  useEffect(() => {
    if (!enabled || !audioTrack || !roomId || !peerId) return

    const capture = new LiveTranscriptionCapture()
    captureRef.current = capture
    void capture.start(audioTrack, roomId, peerId, displayName)

    return () => {
      captureRef.current = null
      void capture.stop()
    }
  }, [enabled, audioTrack, roomId, peerId, displayName])
}
